import {
  backgroundColors,
  backgroundColorsBasic,
  CLEAR_COLOR_NAME,
  colorsGradient,
  DEFAULT_ACCENT_NAME,
  DEFAULT_COLOR_NAME,
  TextLeaf,
} from '@typedream/core';
import { getNode } from '@udecode/plate-core';
import { memo } from 'react';
import shallow from 'zustand/shallow';
import { SelectColor } from '../../../components/SelectColor';
import { useTPlateEditorRef } from '../../../plate';
import { useDreamEditorStore } from '../../../plugins/store';
import { setHighlightColor } from '../../../nodes/text/transforms';
import styles from '../SideToolbar.module.css';

function HightlightColor() {
  const editor = useTPlateEditorRef();

  const options = {
    [CLEAR_COLOR_NAME]: undefined,
    [DEFAULT_ACCENT_NAME]: backgroundColors[DEFAULT_ACCENT_NAME],
    ...backgroundColorsBasic,
    ...colorsGradient,
  };

  const [currentHighlightColor, isDisabled] = useDreamEditorStore((state) => {
    let color = DEFAULT_COLOR_NAME;

    if (state.editor?.selection) {
      const el = getNode<TextLeaf>(editor, state.editor.selection.focus.path);
      if (el?.background) {
        color = el.background;
      }
    }

    return [color, !state.editor?.selection] as [keyof typeof options, boolean];
  }, shallow);

  return (
    <div className={styles.section}>
      <span className={styles.label}>Highlight Color</span>
      <SelectColor
        disabled={isDisabled}
        options={options}
        value={currentHighlightColor}
        onSelect={(v) => setHighlightColor(editor, v)}
      />
    </div>
  );
}

export default memo(HightlightColor);
